import logoUrl from '@/assets/brand/logo.webp'

/**
 * Real EA Studio logo (`slike/mojlogo.webp` on the live site) — copy the
 * source file to `app/src/assets/brand/logo.webp` for this to resolve (see
 * handoff notes: my file tools can move/rename but can't copy a binary file
 * without risking the live plain-HTML site's own reference to the original
 * at `slike/mojlogo.webp`/`.png`, so the copy has to happen on your end).
 */
export function LogoMark({ className = 'h-7 w-7' }: { className?: string }) {
  return <img src={logoUrl} alt="EA Studio" className={`${className} object-contain`} />
}
